const apiMessages = Object.freeze({
  pirdy_catalog_changed: "Prices have changed. Review the refreshed prices and choose again; no payment was started.",
  pirdy_single_change_ineligible: "A Single Change is available only with active paid Cloud Control after all included changes are used.",
  pirdy_account_not_created: "Create your free Pirdy account before continuing.",
  pirdy_account_not_bootstrapped: "This account does not have a Cloud workspace. Your Pirdy account is still signed in and no Cloud change was made.",
  pirdy_platform_only_account: "This identity is for platform administration. Use Pirdy Super Admin, or sign in here with a customer account.",
  pirdy_cloud_read_only: "Cloud Control is unavailable. Review Billing & Usage to activate or renew access before using Cloud features.",
  pirdy_cloud_change_purchase_required: "No Cloud changes remain. Buy a Single Change Pass or activate a monthly plan; Local Control is still available.",
  pirdy_media_in_playlist: "Remove this content from every listed playlist, then try deleting it again.",
  pirdy_credential_rotation_conflict: "The Pirdy changed during recovery. Refresh its status, then retry recovery once.",
  pirdy_firmware_already_assigned: "Every eligible Pirdy already has this update assigned. Refresh before trying again.",
  pirdy_dependency_warming: "Pirdy Cloud is starting. Wait a moment, then try again; no change was confirmed.",
  pirdy_dependency_unavailable: "Pirdy Cloud is temporarily unavailable. Wait a moment, then try again.",
  pirdy_invalid_request: "Pirdy could not use the submitted information. Review your entries and try again; nothing was changed.",
  pirdy_unauthorized: "Your sign-in has expired. Refresh the page, sign in again, and retry.",
  pirdy_forbidden: "Your account does not allow this action. Ask an Organization Administrator if you need access.",
  pirdy_not_found: "That Pirdy item is no longer available. Refresh your account data and choose it again.",
  pirdy_operation_conflict: "The item changed or is not ready for this action. Refresh your account data, review it, and retry once.",
  pirdy_rate_limited: "Too many requests were made. Wait a moment, then retry once.",
  pirdy_service_unavailable: "Pirdy Cloud is temporarily unavailable. Wait a moment, then try again; no change was confirmed.",
  pirdy_internal_error: "Pirdy could not complete the action. Try again later; no result should be assumed.",
});

const operationMessages = Object.freeze({
  pirdy_startup_outcome_unknown: "The setup request may have completed, but its outcome is not yet confirmed. Do not submit it again. Check your account to continue safely.",
  pirdy_configuration_failed: "Pirdy could not load its startup settings. Check your connection, then try again.",
  pirdy_authentication_initialization_failed: "Secure sign-in could not start. Refresh this page, then try again.",
  pirdy_sign_in_failed: "Sign-in was not completed. Close any sign-in window, then try again.",
  pirdy_account_creation_failed: "Account creation was not completed. Close any sign-in window, then try again.",
  pirdy_sign_out_failed: "Sign-out could not be confirmed. Refresh this page before using Pirdy again.",
  pirdy_token_failed: "Pirdy could not refresh your sign-in. Refresh the page, sign in again, and retry.",
  pirdy_network_error: "Pirdy could not be reached. Check your connection and try again; your account data is unchanged.",
});

export function normalizeProblemCode(value) {
  const code = typeof value === "string" ? value.trim().toLowerCase() : "";
  return /^pirdy_[a-z0-9_]{1,64}$/u.test(code) ? code : null;
}

export function customerApiErrorMessage(status, code) {
  const knownCode = normalizeProblemCode(code);
  if (knownCode && apiMessages[knownCode]) return apiMessages[knownCode];
  if (status === 400) return apiMessages.pirdy_invalid_request;
  if (status === 401) return apiMessages.pirdy_unauthorized;
  if (status === 403) return apiMessages.pirdy_forbidden;
  if (status === 404) return apiMessages.pirdy_not_found;
  if (status === 409) return apiMessages.pirdy_operation_conflict;
  if (status === 429) return apiMessages.pirdy_rate_limited;
  if (Number(status) >= 500) return apiMessages.pirdy_internal_error;
  return "Pirdy could not complete the request. Refresh your account data and try again; no result should be assumed.";
}

export function customerOperationError(code, cause) {
  const normalized = normalizeProblemCode(code) ?? "pirdy_request_failed";
  const error = new Error(operationMessages[normalized] ??
    "Pirdy could not complete the action. Try again; no result should be assumed.");
  error.code = normalized;
  error.customerSafe = true;
  if (cause !== undefined) error.cause = cause;
  return error;
}

export function customerVisibleErrorMessage(error, fallback) {
  return error?.customerSafe === true && typeof error.message === "string" && error.message.trim()
    ? error.message
    : fallback;
}
